import { API_ROUTES, API_ROUTE_V2_PREFIX_HTTPS } from "@tm/api-utils";
import { PARTNER } from "@tm/isomorphic-utils";

interface DownloadTemplateErrorResponse {
  responseStatus: string;
  message?: string;
  error?: {
    code?: string;
    message?: {
      icon?: string;
      title?: string;
      description?: string;
    };
    localizations?: Record<string, unknown> | null;
  };
}

export const downloadTemplate = async (itineraryId: string): Promise<void> => {
  try {
    const response = await fetch(
      `${API_ROUTE_V2_PREFIX_HTTPS}/${PARTNER.MMT}/${API_ROUTES.DOWNLOAD_TEMPLATE}?itineraryId=${itineraryId}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      // Try to parse error response to extract error.message.description
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorData: DownloadTemplateErrorResponse = await response.json();
        const errorDescription = errorData?.error?.message?.description;
        if (errorDescription) {
          errorMessage = errorDescription;
        }
      } catch {
        // JSON parsing failed, use default error message
      }
      throw new Error(errorMessage);
    }

    // Extract filename from Content-Disposition header if available
    const contentDisposition = response.headers.get("Content-Disposition");
    let downloadFileName = "passenger_template.xlsx";

    if (contentDisposition) {
      // Try to extract filename from header (handles both filename="..." and filename*=UTF-8''...)
      const filenameMatch = contentDisposition.match(
        /filename\*?=['"]?(?:UTF-8'')?([^"';\n]+)['"]?/i
      );
      if (filenameMatch && filenameMatch[1]) {
        downloadFileName = decodeURIComponent(filenameMatch[1]);
      }
    }

    // Get the blob from the response
    const blob = await response.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = downloadFileName;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    throw error;
  }
};
